/**
 * {@link https://oss.navercorp.com/place/my_plan/issues/4545#issuecomment-12086848}
 */
export const lils = {
  // 피드탭
  feed: {
    REGION_AROUND_URL: 'lils.feed2regionarurl', // 위치정보>피드탭 현위치탭
    REGION_AROUND: 'lils.feed2regionar', // 위치정보>피드탭 현위치 URL 접속
  },
  // 테마리스트
  themelist: {
    MY_MAP_NOW: 'lils.mythememapnow', // 위치정보>테마리스트(작성자뷰) 지도
    MAP_NOW: 'lils.themelistmapnow', // 위치정보>테마리스트(타인뷰) 지도
  },
  // 저장탭
  save: {
    AROUND_BOOKMARK_STATIC_MAP: 'lils.savearbmkstaticmap', // 위치정보>이 주변 저장장소 스태틱맵
    AROUND_BOOKMARK_DYNAMIC_MAP: 'lils.savearbmkdynamicmap', // 위치정보>이 주변 저장장소 다이나믹맵
    DEFAULT_LIST_MAP_NOW: 'lils.savedefaultlistmapnow', // 위치정보>이주변 저장장소 지도 현위치
    AROUND_BOOKMARK_LOCATION: 'lils.savearoundbmklocation', // 위치정보>내장소&저장리스트 공통 지도 현위치
    AROUND_BOOKMARK_TABLE_DISTANCE_SORT: 'lils.savearoundbmktabledissort', // 위치정보>이주변 저장장소 거리순 정렬
    DEFAULT_LIST_DISTANCE_SORT: 'lils.savedefaultlistdissort', // 위치정보>내장소 거리순 정렬
    MY_LIST_DISTANCE_SORT: 'lils.savemylistdissort', // 위치정보>내가만든저장리스트 거리순 정렬
    OTHER_LIST_DISTANCE_SORT: 'lils.saveotherlistdissort', // 위치정보>내가저장한타인저장리스트 거리순 정렬
    SHARED_LIST_DISTANCE_SORT: 'lils.savesharedlistdstcsort', // 위치정보>타인공유저장리스트 거리순 정렬
  },
  my: {
    /**
     * @see https://wiki.navercorp.com/pages/viewpage.action?pageId=2558051605 > 클릭코드 영역
     * 홈 > 데일리브리핑 > 지도뷰
     */
    MY_DAILYBRIEFING_LOCATION: 'lils.dailybriefingnow',
    /**
     * @see https://wiki.navercorp.com/pages/viewpage.action?pageId=2561214085 > 클릭코드 영역
     * 홈 > 타임라인카드 > 지도뷰
     */
    MY_TIMELINE_MAP_LOCATION: 'lils.timelinemapnowemptycase',
    /**
     * @see https://wiki.navercorp.com/pages/viewpage.action?pageId=2563423275 > 클릭코드 영역
     * 타임라인 페이지 > 지도뷰
     */
    TIMELINE_PAGE_MAP: 'lils.timelinepgmapnow',
  },
}
